<template style="height: 100%;">
    <div style="width: 100%;height: 100%;display: flex" id="homeBox">
        <el-row class="video-tree flex" style="width: 100%;">

            <el-col :span="treespan"  v-show="isright"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <left-tree ref="tree"  @showData="showData" @detailPage="bmdetailPage"></left-tree>
            </el-col>
            <el-col :span="rightspan" id="tabelBox" style="height: 100%;min-width: 320px;width: 100%;flex: 1">

            <div  style="display: flex">
                <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>

                <div class="df">
                    <div style="display:flex;;">
<!--                        <el-button type="text" style="height: 2.857rem;margin-right: 20px"  icon="el-icon-plus"  @click="add">新增</el-button>-->
                        <el-select v-model="i_rystate" size="mini" placeholder="人员状态" filterable clearable
                                   style="width:100%; ">
                            <el-option v-for="item in i_rystateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                        </el-select>
                        <el-select v-model="i_userState" size="mini" placeholder="用户状态" filterable clearable
                                   style="width:100%; ">
                            <el-option v-for="item in i_isuserList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                        </el-select>
                        <el-input  class="marr4" style=""  v-model="vc_search" placeholder="请输入" clearable size="mini"></el-input>
                        <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>

                    </div>
                </div>
            </div>
            <el-table  class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                       :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>
                <el-table-column prop="i_userid" label="用户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="vc_username" label="用户姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="vc_login" label="登陆名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="vc_dept" label="所属机构" show-overflow-tooltip></el-table-column>
                <el-table-column prop="i_isuser" label="系统登陆" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i class="el-icon-check" v-if="scope.row.i_isuser==1" style="color: green"></i>
                        <i class="el-icon-close" v-if="scope.row.i_isuser==0" style="color: red"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="vc_rystate" label="人员状态" show-overflow-tooltip></el-table-column>
<!--                <el-table-column width="100" label="操作">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-button  type="text" size="mini" @click="detailFun(scope.row,)">详情</el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
            <!--        分页器-->
            <div class="block">
                <div class="pages">
                    <div class="choosepage flexother mrt20 fl">
                        <el-pagination small @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="this.currentPage"
                                :page-sizes="[20, 40, 60, 80]" :page-size="this.pageSize" layout="total,sizes" :total="this.total">
                        </el-pagination>
                        <el-pagination small :pager-count="5" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="this.currentPage" :page-size="this.pageSize" layout="prev, pager, next, jumper" :total="this.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div :class="baseerp+'div'">
                <el-dialog :title="bmTitle" width="600px"  :visible.sync="bmDialog"
                           :close-on-click-modal="false" @close="bmClose">
                    <bm-detail :data="bmProp" v-if="bmDialog" @close="bmClose"></bm-detail>
                </el-dialog>

            </div>


            </el-col>
        </el-row>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";

    // import tabTree from "./tabTree";
    import LeftTree from "./LeftTree";
    // import DetailPage from "./DetailPage";
    import BmDetail from "./BmDetail";
    export default {
        name: "workManage",
        components:{

            LeftTree,
            BmDetail

            // tabTree
        },
        data(){
            return{
                isright:true,//树显示按钮
                tableData: [],//列表数据
                currentPage:1,//页
                pageSize:20,//条
                total:0,//总数
                baseerp:'',//公共样式
                tableHeight:0,//列表高度
                bmTitle:'',
                bmDialog:false,
                bmProp:{},
                treespan:4,
                rightspan:20,
                treeData:{},
                i_rystateList:[{i_id:1,vc_name:'在职'},{i_id:-1,vc_name:'离职'},{i_id:2,vc_name:'核算'}],
                i_rystate:'',
                i_userState:'',
                i_isuserList:[{i_id:1,vc_name:'启用'},{i_id:0,vc_name:'无OA许可'},{i_id:-1,vc_name:'禁用'}],
                vc_search:'',
            }
        },
        activated(){
            this.onResize();
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },

        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();
            })
            // this.getUserList()
        },
        methods:{

            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            ...mapActions(["getCurrentMenuId"]),
            detailFun(){},
            bmClose(type='back'){
              this.bmDialog=false;
                if(type=='save'){
                    this.$refs.tree.refreshTree()
                }
            },
            bmdetailPage(val,type){
                this.bmDialog=true;
                if(type=='add'){
                    this.bmTitle='新增'
                }else{
                    this.bmTitle='编辑'
                }
                this.bmProp={
                    data:val,
                    type:type
                }
            },
            showData(val){
                this.treeData=val;
                this.currentPage =1;
                this.getUserList();
           },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getUserList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getUserList();
            },
            searchFun(){
                this.currentPage=1
                this.getUserList()
            },
            async getUserList() {
                let params = {
                    i_dept:this.treeData.i_id,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    i_rystate:this.i_rystate,
                    i_userState:this.i_userState,
                    vc_search:this.vc_search,
                };
                let res = await API.getUserList(params);
                if (res.code == 1) {
                    this.tableData=res.data.userList;
                    this.total=res.data.total;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }
    .df{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .row-expand-cover .el-table__expand-icon {
            visibility: hidden;
        }
        .el-table--enable-row-transition{
            /*min-width: 64.286rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }
    /deep/{
        .el-dialog{
            min-width: 900px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table__expanded-cell[class*=cell]{
            padding: 5px;
        }
        .dtj{
            color: #409EFF;
        }
        .tg{
            color: #03cb45;
        }
        .spz{
            color: #ffbe06;
        }
        .wtg{
            color: #ff0500;
        }
        .yzf{
            color: #878787;
        }
    }

</style>